import { IconProps } from '@/modules/defines/interface';

const Elevator = ({ fill, width, height }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '32'}
      height={height || '32'}
      viewBox={'0 0 32 32'}
      fill="none"
    >
      <path d="M28 13.7346L29.25 12.3571L30.5 13.7346H28Z" fill={fill} />
      <path d="M30.5 18.5714L29.25 19.9489L28 18.5714H30.5Z" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.25 10.8571C29.6731 10.8571 30.0765 11.0358 30.3608 11.3491L31.6108 12.7266C32.0096 13.1661 32.1118 13.7995 31.8715 14.3421C31.6312 14.8847 31.0935 15.2346 30.5 15.2346H28C27.4065 15.2346 26.8688 14.8847 26.6285 14.3421C26.3882 13.7995 26.4904 13.1661 26.8892 12.7266L28.1392 11.3491C28.4235 11.0358 28.8269 10.8571 29.25 10.8571ZM26.6285 17.964C26.8688 17.4213 27.4065 17.0714 28 17.0714H30.5C31.0935 17.0714 31.6312 17.4213 31.8715 17.964C32.1118 18.5066 32.0096 19.1399 31.6108 19.5794L30.3608 20.9569C30.0765 21.2703 29.6731 21.4489 29.25 21.4489C28.8269 21.4489 28.4235 21.2703 28.1392 20.9569L26.8892 19.5794C26.4904 19.1399 26.3882 18.5066 26.6285 17.964Z"
        fill={fill}
      />
      <path
        d="M13 31H6.46C5.1 31 4 29.8607 4 28.4521V4.54786C4 3.13929 5.1 2 6.46 2H13V31Z"
        fill={fill}
      />
      <path
        d="M15 2H21.54C22.9 2 24 3.13929 24 4.54786V28.4521C24 29.8607 22.9 31 21.54 31H15V2Z"
        fill={fill}
      />
    </svg>
  );
};

export default Elevator;
